<template>
    <div v-if="content" class="warm-tips">
        <div class="warm-tips-title">温馨提示：</div>
        <div class="warm-tips-content" v-on:click="handleClick" v-html="renderHtml"></div>
        <el-dialog
            :title="protocolTitle"
            :visible.sync="protocolVisible"
            width="70%"
            top="8vh"
            append-to-body
        >
            <div class="protocol-scroll">
                <!-- 富文本协议 -->
                <div v-if="protocolContent" v-html="protocolContent" />

                <!-- 文件协议 -->
                <div
                    v-else-if="filePath"
                    v-loading="fileLoading"
                    style="justify-content: center; display: flex"
                >
                    <iframe
                        ref="iframe"
                        :src="filePath"
                        style="width: 800px; height: 400px; border: none"
                        v-on:load="onLoad"
                    />
                </div>
            </div>

            <div slot="footer" class="dialog-footer align-c">
                <el-button type="primary" v-on:click="protocolVisible = false">我已知晓</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
const PDF_VIEWER = "/js/pdfjs/web/viewer.html";
export default {
    name: "WarmTips",
    props: {
        content: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            protocolVisible: false, // 控制弹框
            protocolTitle: "",
            protocolContent: "",
            filePath: "",
            fileLoading: false
        };
    },
    computed: {
        renderHtml() {
            if (!this.content) return "";
            return this.transformHtml(this.content);
        }
    },
    methods: {
        transformHtml(html) {
            return html.replace(/<a\s+([^>]*?)href="([^"]+)"([^>]*)>/gi, (match, preAttr, href) => {
                // http(s) 直接放行
                if (/^https?:\/\//i.test(href)) {
                    return match;
                }

                return `<a href="javascript:void(0)" data-href="${href}" class="protocol-link">`;
            });
        },
        /**
         * 统一点击拦截
         */
        handleClick(e) {
            const target = e.target.closest("a");
            if (!target) return;

            const href = target.dataset.href;
            if (!href) return;

            e.preventDefault();

            const params = this.parseHrefParams(href);

            const scene = params.scene || "";
            const policytype = params.policytype || "";

            // 至少要有一个
            if (!scene && !policytype) {
                console.warn("协议参数缺失:", href);
                return;
            }

            this.openProtocol(scene, policytype);
        },
        parseHrefParams(href) {
            const params = {};

            href.split("&").forEach((pair) => {
                const [key, value] = pair.split("=");
                if (key && value) {
                    params[key] = decodeURIComponent(value);
                }
            });

            return params;
        },
        // 打开协议（文件 / 富文本）
        async openProtocol(scene, policytype) {
            try {
                const res = await this.$util.getProtocol(scene || "", "", policytype || "");

                if (!res || !res.length) return;

                const data = res[0];
                this.protocolTitle = data.title || "协议内容";

                this.protocolContent = "";
                this.filePath = "";

                if (data.fileid) {
                    this.handlePdfUrlChange(data.fileid);
                    this.protocolVisible = true;
                    return;
                }

                if (data.content) {
                    this.protocolContent = data.content;
                    this.protocolVisible = true;
                    return;
                }
            } catch (e) {
                console.error("协议打开失败", e);
            }
        },
        handlePdfUrlChange(fileId) {
            if (!fileId) return;

            this.fileLoading = true;
            const fileGet = this.$util.fileDownloadPath(fileId);

            this.filePath =
                PDF_VIEWER +
                "?file=" +
                encodeURIComponent(fileGet) +
                `&rand=${Date.now()}` +
                "#page=1&toolbar=0";
        },

        onLoad() {
            const iframe = this.$refs.iframe;
            this.$nextTick(() => {
                try {
                    iframe.contentWindow.PDFViewerApplication.appConfig.toolbar.container.classList.add(
                        "hidden"
                    );
                } catch (e) {
                    console.log(e);
                }
                this.fileLoading = false;
            });
        }
    }
};
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
    padding: 20px;
}

.dialog-footer {
    text-align: center;
}
.warm-tips {
    margin-top: 24px;
    padding: 16px 20px;
    border-radius: 6px;
    color: var(--color-text-accent);
    font-size: 13px;
    line-height: 1.8;

    .warm-tips-title {
        font-weight: 500;
        margin-bottom: 8px;
    }

    .warm-tips-content {
        p {
            margin: 0 0 6px;
        }

        a {
            color: #4290f7;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .protocol-content {
        max-height: 70vh;
        overflow-y: auto;
        padding: 0 8px;
        line-height: 1.8;
        color: var(--color-text-primary);

        h1,
        h2,
        h3 {
            text-align: center;
            margin: 16px 0;
        }

        p {
            margin: 8px 0;
        }
    }
}

/* ===============================
 * 协议弹框固定高度 + 内容滚动
 * =============================== */
::v-deep .el-dialog {
    height: 80vh; /* 弹框整体高度 */
    display: flex;
    flex-direction: column;
}

::v-deep .el-dialog__body {
    flex: 1; /* 占满中间区域 */
    overflow: hidden; /* 禁止 body 自己滚动 */
    padding: 0; /* 交给内部内容控制 */
}

::v-deep .el-dialog__footer {
    flex-shrink: 0; /* footer 固定在底部 */
}

/* 内容滚动区域（富文本 / iframe 都生效） */
::v-deep .el-dialog__body > div {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;
}

/* iframe 协议高度铺满 */
::v-deep .el-dialog__body iframe {
    height: 100%;
    border: none;
}

/* 可选：滚动条美化 */
::v-deep .el-dialog__body > div::-webkit-scrollbar {
    width: 6px;
}

::v-deep .el-dialog__body > div::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
}
</style>
